import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class BbdRecentlyViewed extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  async #init() {
    const productIds = RecentlyViewed.getProducts();

    if (productIds.length === 0) {
      this.classList.add('hidden');
      return;
    }

    const sectionId = this.dataset.sectionId || this.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    if (!sectionId) return;

    const searchUrl = new URL(`${window.location.origin}/search`);
    searchUrl.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    searchUrl.searchParams.set('resources[type]', 'product');
    searchUrl.searchParams.set('section_id', sectionId);

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, searchUrl);
      if (html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newContent = temp.querySelector('bbd-recently-viewed');

        if (newContent && newContent.innerHTML.trim().length > 0) {
          this.innerHTML = newContent.innerHTML;
          this.classList.remove('hidden');
        } else {
          this.classList.add('hidden');
        }
      }
    } catch (error) {
      console.error('RecentlyViewed Error:', error);
      this.classList.add('hidden');
    }
  }
}

if (!customElements.get('bbd-recently-viewed')) {
  customElements.define('bbd-recently-viewed', BbdRecentlyViewed);
}
